import React from "react";
import styles from "./PastilleScore.module.css";

const PastilleScore = ({ color }) => <div className={styles.circle} data-color={color} />;

export default PastilleScore;
